module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/_babel-runtime@6.26.0@babel-runtime/regenerator/index.js
// module id = lC5x
// module chunks = 11